module.exports = __webpack_public_path__ + "img/max-office-building-deny.bdce999d.svg";